// Port z partials.js linie 1156-1241 (bindMobileMenu).
// Etap 3: dopisany handler [data-mm-search] (1225-1240) — close mobile drawer, after 320ms open search drawer.

export function initMobileDrawer() {
  const drawer = document.getElementById('mobile-menu');
  if (!drawer) return;
  // Idempotent — gdyby kiedyś (po wc_fragments_refreshed albo jQuery DOM ready)
  // initMobileDrawer dostał drugie wywołanie, listenery by się dublowały.
  if (drawer.__kbMmBound) return;
  drawer.__kbMmBound = true;
  const panel = drawer.querySelector('[data-mm-panel]');
  const backdrop = drawer.querySelector('[data-mm-backdrop]');

  function open() {
    drawer.classList.remove('pointer-events-none');
    drawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => {
      backdrop.style.opacity = '1';
      panel.classList.remove('-translate-x-full');
    });
    document.documentElement.style.overflow = 'hidden';
  }
  function shut() {
    drawer.setAttribute('aria-hidden', 'true');
    backdrop.style.opacity = '0';
    panel.classList.add('-translate-x-full');
    setTimeout(() => { drawer.classList.add('pointer-events-none'); }, 280);
    document.documentElement.style.overflow = '';
  }

  document.querySelectorAll('[data-mobile-menu-toggle]').forEach((b) => b.addEventListener('click', open));
  // NOTE: [data-mm-close] + backdrop close są opakowane przez wrappedShut niżej (resetuje stack).
  // Tu pomijamy żeby nie bindować dwóch listenerów na tym samym przycisku.
  drawer.querySelectorAll('a[href]:not([data-mm-back])').forEach((a) => a.addEventListener('click', shut));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') shut();
  });

  // Stack navigation: each [data-mm-screen] is an absolutely-positioned page.
  const stack = ['root'];
  function screenEl(name) { return drawer.querySelector('[data-mm-screen="' + name + '"]'); }
  function pushTo(target) {
    const cur = stack[stack.length - 1];
    const curEl = screenEl(cur);
    const tgtEl = screenEl(target);
    if (!curEl || !tgtEl || cur === target) return;
    tgtEl.classList.remove('mm-screen-right');
    tgtEl.classList.add('mm-screen-active');
    curEl.classList.remove('mm-screen-active');
    curEl.classList.add('mm-screen-left');
    tgtEl.scrollTop = 0;
    stack.push(target);
  }
  function popOne() {
    if (stack.length < 2) return;
    const popped = stack.pop();
    const popEl = screenEl(popped);
    const prev = stack[stack.length - 1];
    const prevEl = screenEl(prev);
    if (!popEl || !prevEl) return;
    popEl.classList.remove('mm-screen-active');
    popEl.classList.add('mm-screen-right');
    prevEl.classList.remove('mm-screen-left');
    prevEl.classList.add('mm-screen-active');
  }
  function resetToRoot() {
    while (stack.length > 1) popOne();
  }
  drawer.querySelectorAll('[data-mm-go]').forEach((b) => b.addEventListener('click', () => pushTo(b.getAttribute('data-mm-go'))));
  drawer.querySelectorAll('[data-mm-back]').forEach((b) => b.addEventListener('click', popOne));

  // Reset stack to root after close animation
  const wrappedShut = function () { shut(); setTimeout(resetToRoot, 320); };
  drawer.querySelectorAll('[data-mm-close]').forEach((b) => b.addEventListener('click', wrappedShut));
  backdrop.addEventListener('click', wrappedShut);

  // Search button inside mobile drawer header: close mobile drawer, then open search
  // drawer once the close animation has cleared (avoids z-index stacking issues).
  // Port partials.js linie 1225-1240.
  drawer.querySelectorAll('[data-mm-search]').forEach((b) => b.addEventListener('click', () => {
    wrappedShut();
    setTimeout(() => {
      const sd = document.getElementById('search-drawer');
      if (!sd) return;
      sd.classList.remove('pointer-events-none');
      sd.setAttribute('aria-hidden', 'false');
      const bg = sd.querySelector('[data-search-backdrop]');
      const pn = sd.querySelector('[data-search-panel]');
      const inp = sd.querySelector('[data-search-input]');
      if (bg) bg.style.opacity = '1';
      if (pn) pn.style.transform = 'translateY(0)';
      if (inp) setTimeout(() => inp.focus(), 80);
      document.body.style.overflow = 'hidden';
    }, 320);
  }));
}

// Expose dla hydrate — mobile-drawer siedzi w <template>, hydratujemy przy 1. kliknięciu hamburgera.
if (typeof window !== 'undefined') {
  window.kbInitMobileDrawer = initMobileDrawer;
}

// Fallback: gdy drawer jest już w DOM (np. lokalne dev bez template), init odpalimy jak dawniej.
if (typeof document !== 'undefined') {
  const runIfPresent = () => { if (document.getElementById('mobile-menu')) initMobileDrawer(); };
  if (document.readyState !== 'loading') runIfPresent();
  else document.addEventListener('DOMContentLoaded', runIfPresent);
}
